import { Button, Stack, SvgIcon } from "@mui/joy";
import { motion } from "framer-motion";
import { DownArrowSvg } from "static/image/common/SvgAssets";
import { extractHexColor } from "styles/hexOpacity";
import { theme } from "styles/theme";

interface PreviewGoNextButtonProps {
  disabled: boolean;
  onClick: () => void;
}

// v1 GoNextBlockButton 과 동일 외형. disabled 시 미렌더 (레이아웃 점프 OK).
// 펄스 애니메이션은 v1 에서 특정 활동지에서만 발생하는 분기 케이스이므로 제거.
function PreviewGoNextButton({ disabled, onClick }: PreviewGoNextButtonProps) {
  const activatedColor = extractHexColor(theme.vars.palette.Content.Highlight);

  if (disabled) return <></>;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ ease: "easeInOut", duration: 0.3 }}
    >
      <Button
        size="lg"
        onClick={onClick}
        variant={"Plain" as any}
        sx={{
          width: "100%",
          minHeight: "46px",
          backgroundColor: "transparent",
          mt: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <SvgIcon
            sx={{
              width: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            inheritViewBox
          >
            <DownArrowSvg color={activatedColor} />
          </SvgIcon>
        </Stack>
      </Button>
    </motion.div>
  );
}

export default PreviewGoNextButton;
